export const HEADER_ROW_ID = "header";

export const ROW_HEIGHT = 32;
export const HEADING_ROW_HEIGHT = 40;
